"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Message = function Message() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 3.667H7A3.333 3.333 0 003.667 7v12.917c0 .23.186.416.416.416.11 0 .216-.045.292-.125l2.5-2.5A2.5 2.5 0 018.667 17H17a3.333 3.333 0 003.333-3.333V7A3.333 3.333 0 0017 3.667zm-3.333 8.75c0 .23-.187.416-.417.416H7.417A.417.417 0 017 12.417v-.834c0-.23.187-.416.417-.416h5.833c.23 0 .417.186.417.416v.834zM16.583 9.5c.23 0 .417-.186.417-.417V8.25a.417.417 0 00-.417-.417H7.417A.417.417 0 007 8.25v.833c0 .23.187.417.417.417h9.166z",
    clipRule: "evenodd"
  });
};

exports.Message = Message;